import { GreenDotIcon, RedDotIcon } from '@/components/Icons';
import { format, R } from '@/features/profile/resources/ProfileResources.resx';
import { Link } from 'react-router';
import { HorizontalContainer, VerticalContainer } from '@/components';
import { SubscriptionDetailsResponse } from '@/features/profile/model/types';

export const SubscriptionCard = ({
    subscription,
}: {
    subscription: SubscriptionDetailsResponse;
}) => {
    return (
        <Link
            aria-label={format(
                R.SubscriptionLinkLabelA11y,
                subscription.Title ?? '',
            )}
            to={`/SubscriptionDetails?subscriptionId=${subscription.SubscriptionId}`}
            className="h-full min-h-28 cursor-pointer rounded-2xl border border-(--color-border-muted) p-4 hover:bg-(--color-bg-subtle)"
        >
            <VerticalContainer spacing="sm">
                <HorizontalContainer
                    spacing="xs"
                    className="min-h-7 items-center text-sm whitespace-nowrap"
                >
                    {subscription.IsActive && (
                        <GreenDotIcon className="size-2" />
                    )}
                    {!subscription.IsActive && (
                        <RedDotIcon className="size-2" />
                    )}
                    {subscription.StatusText}
                </HorizontalContainer>

                <div className="overflow-hidden leading-tight font-bold text-ellipsis whitespace-nowrap text-(--color-text-heading)">
                    {subscription.Title}
                </div>

                <div className="text-text-secondary leading-normal">
                    {subscription.NextPaymentText}: {subscription.NextPayment}
                </div>
            </VerticalContainer>
        </Link>
    );
};
